import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { MotivoPerdaVendaSituacaoBadgeComponent } from './badge';
import { MotivoPerdaVendaSituacaoSelectComponent } from './select';
import { MotivoPerdaVendaSituacaoMultiselectComponent } from './multiselect';
import { MotivoPerdaVendaSituacaoPipe } from './pipes';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        MotivoPerdaVendaSituacaoBadgeComponent,
        MotivoPerdaVendaSituacaoSelectComponent,
        MotivoPerdaVendaSituacaoMultiselectComponent,

        // Pipes
        MotivoPerdaVendaSituacaoPipe
    ],
    exports: [
        MotivoPerdaVendaSituacaoBadgeComponent,
        MotivoPerdaVendaSituacaoSelectComponent,
        MotivoPerdaVendaSituacaoMultiselectComponent,

        // Pipes
        MotivoPerdaVendaSituacaoPipe
    ],
    providers: [
        // Pipes
        MotivoPerdaVendaSituacaoPipe
    ]
})
export class MotivoPerdaVendaSituacaoModule { }
